import axios from 'axios';
import moment from 'moment';

//not done by redux action 
export const getB2CSettings = (webappurl) => {
    const response = axios.get(webappurl + "/api/myCASA/Portal/GetB2CSettings/v1");
    return response; 
}

export const iOSversion = () => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        if (window.indexedDB) { return 'iOS 8 and up'; }
        if (window.SpeechSynthesisUtterance) { return 'iOS 7'; }
        if (window.webkitAudioContext) { return 'iOS 6'; }
        if (window.matchMedia) { return 'iOS 5'; }
        if (window.history && 'pushState' in window.history) { return 'iOS 4'; }
        return 'iOS 3 or earlier';
    }

    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        return "Firefox";
    }

    return 'Not an iOS device';
}

export const urlSearchValue = (token) => {
    let desiredVal = null;
    let paramName = token;
    window.location.search.substring(1).split('&').some(function (currentValue) {
        let nameVal = currentValue.split('=');
        if (decodeURIComponent(nameVal[0]) === paramName) {
            desiredVal = decodeURIComponent(nameVal[1]);
            return true;
        }
        return false;
    });
    return desiredVal;
};

export const getParamValue = (token) => {
    let desiredVal = null;
    let paramName = token;
    window.location.search.substring(1).split('&').some(function (currentValue) {
        var nameVal = currentValue.split('=');
        if (decodeURIComponent(nameVal[0]) === "params") {
            let param = JSON.parse(atob(decodeURIComponent(nameVal[1])));
            desiredVal = param[paramName];
            return true;
        }
        return false;
    })
    return desiredVal;
};

export const getUserHomePage = (srarnsIndividual, draftarnsIndividual, userdetails, tagsIndividual, acceptedSRsIndividual, participants) => {
    let SRARNPending = !srarnsIndividual.items ? false : srarnsIndividual.items.value.length > 0;  //New or InProgress SR for these forms: Form 1162 - ARN - Individual,Form 1162B - Link ARN,Form 1162A - 100 Point check 
    
    let ARNPending = !draftarnsIndividual ? false : !draftarnsIndividual.items ? false : !draftarnsIndividual.items.savedARNAppsArr ? false : draftarnsIndividual.items.savedARNAppsArr.length > 0; //  + draftarnsIndividual.items.savedARNLinkAppsArr.length + draftarnsIndividual.items.savedPOIAppsArr.length > 0; //Draft AEM Apps for these forms: Form 1162 - ARN - Individual,Form 1162B - Link ARN,Form 1162A - 100 Point check 
    if (!userdetails ? false : !userdetails.items ? false : !userdetails.items.value ? false : userdetails.items.value.length === 0 ? false : userdetails.items.value[0].casa_arn === "" || !userdetails.items.value[0].casa_arn) {
        /////////1. User does not have ARN. 
        /////////Then if user has saved application or applied Application > Goto Individual Dashboard
        /////////Else goto Link ARN

        if (ARNPending || SRARNPending) {
            //user has saved-application (AEM: ARN or LinkARN) or submitted-application that is in New/InProgress status (D365)
            //user will be redirected to Individual Dashboard
            return "dashind";
        }
        else {
            return "linkarn";
        }
    }
    else {
        /////////2. User has ARN. 
        /////////Then if user has saved application or applied Application > Goto Individual Dashboard
        /////////Else If user does not have Verified-tag and does not have Accepted Service Request of type "Form 1162A - 100 Point check" > Goto Verify POI

        if (ARNPending || SRARNPending) {
            //user has saved-application (AEM: Verify POI) or submitted-application that is in New/InProgress status (D365)
            //user will be redirected Individual Dashboard
            return "dashind";
        }
        else {
            //debugger;
            let indTags = !tagsIndividual.items ? 0 : tagsIndividual.items.value.length;
            let indAcceptedSR = !acceptedSRsIndividual.items ? 0 : acceptedSRsIndividual.items.length;

            //if the user does not have any Verified-tag then force user to Verify POI
            if (indTags === 0 && indAcceptedSR === 0 && (userdetails.items.value[0].casa_arn)) {
                return "verifypoi";
            }
        }
    }

    /////////3. User has ARN and has been verified :)
    if (participants.items.hasParticipants) {
        return "profileselector";
    }
    else {
        return "dashind";
    }
}

export const IsVerifiedUserWithARN = (props) => {
   
    if (props.userdetails.items.value[0].casa_arn === "") {
        return false;
    }
    else {
        let indTags = props.tagsIndividual.items.length;
        let indAcceptedSR = props.acceptedSRsIndividual.items.length;

        //if the user does not have any Verified-tag then return false;
        return (indTags > 0 || indAcceptedSR > 0);
    }
}

export const  CanUserSelectProfile = (homePage) => {
    return (homePage === "profileselector");
}

export const  UserMustSubmitIndividualARNApplication = (homePage) => {
    return (homePage === "linkarn");
}

export const  UserMustVerifyPOI = (homePage) => {
    return (homePage === "verifypoi");
}

export const getPortalUrl = (page, standalone, urlHome) => {
    if (standalone) {
        return window.location.origin + '/forms' + page + '?standalone=' + standalone;
    }
    else {
        return urlHome + page + '?standalone=' + standalone;
    }    
}

export const stringIsNullOrEmpty = (value) => {
    return !(value && typeof value === "string" && value.length > 0);
}

export const FeatureAvailable = (feature) => {
    let availDate = moment(feature, "DD/MM/YYYY");          

    let available = availDate.isBefore();

    return available ? true : false;
} 

/* checks guid is valid */
export const isUUID = (uuid) => {
    let s = "" + uuid;

    s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
    if (!s) {
        return false;
    }
    return true;
}

export const setInnerHTML = (value) => {
    return { __html: value };
};

